/* eslint-disable linebreak-style */
export default { url: `${process.env.REACT_APP_GRAPHQL_SERVER_BASE_URL}/api/` };
